<template>
    <v-card class="sitemap-analyzer tools-view-card">
        <ToolbarHeader :name="'Sitemap-Analyzer'"/>
        <v-container>
            <section class="ma-5">
                <v-form
                        v-model="formOptions.valid"
                        v-on:submit.prevent="formSubmit()"
                >
                    <v-row justify="center">
                        <v-col cols="12"
                               sm="12"
                               md="6">
                            <v-text-field
                                    v-model="form.url"
                                    required
                                    :rules="[formOptions.urlValidator]"
                                    name="Url"
                                    label="Url"
                            />
                        </v-col>
                        <v-col cols="12"
                               sm="12"
                               md="2">
                            <v-btn
                                    :disabled="!formOptions.valid"
                                    type="submit"
                                    color="primary"
                                    class="mt-3 w-100"
                            >
                                Analyze
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12"
                               sm="12"
                               md="12">
                                <pre>
                                    {{SITEMAP_ANALYZER_DATA}}
                                </pre>
                        </v-col>
                    </v-row>
                </v-form>
            </section>
        </v-container>
    </v-card>
</template>
<script>
    import {mapGetters} from "vuex";
    import ToolbarHeader from "@/components/Toolbar-Header";

    const form = {
        url: 'http://quasiris.de'
    };

    export default {
        name: 'Sitemap-Analyzer',
      components: {ToolbarHeader},
      data: () => ({
            form: Object.assign({}, form),
            formOptions: {
                valid: false,
                urlValidator(value) {
                    if (!value) {
                        return false
                    }
                    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
                    if (pattern.test(value)) {
                        return true;
                    }

                    return 'Url is not correct!';

                }
            },
        }),
        computed: {
            ...mapGetters([
                'SITEMAP_ANALYZER_DATA',
            ]),
        },
        methods: {
            formSubmit() {
                this.$store.dispatch('GET_SITEMAP_ANALYZER_DATA', {form: this.form});
            },
        }
    }
</script>
